/** Планшет и уже: карточки вместо таблицы. 1024px — включает iPad в альбомной ориентации. */
export const TECHNICAL_MAP_TABLET_MEDIA_QUERY = '(max-width: 1024px)';

/** Мобильная версия техкарты. */
export const TECHNICAL_MAP_MOBILE_MEDIA_QUERY = '(max-width: 700px)';
export const technicalMapMobileMq = `@media ${TECHNICAL_MAP_MOBILE_MEDIA_QUERY}`;

/** Кнопки в карточках — вертикально. */
export const TECHNICAL_MAP_CARD_BUTTONS_STACK_MEDIA_QUERY = '(max-width: 600px)';
export const technicalMapCardButtonsStackMq = `@media ${TECHNICAL_MAP_CARD_BUTTONS_STACK_MEDIA_QUERY}`;

/** Поля карточки: «Название: значение» в одной строке. */
export const TECHNICAL_MAP_CARD_FIELDS_INLINE_MEDIA_QUERY = '(max-width: 500px)';
export const technicalMapCardFieldsInlineMq = `@media ${TECHNICAL_MAP_CARD_FIELDS_INLINE_MEDIA_QUERY}`;

/** Узкие фильтры: стрелки слева от лейбла, даты столбиком. */
export const TECHNICAL_MAP_FILTER_NARROW_MEDIA_QUERY = '(max-width: 450px)';
export const technicalMapFilterNarrowMq = `@media ${TECHNICAL_MAP_FILTER_NARROW_MEDIA_QUERY}`;

/** Кнопки фильтров — вертикально. */
export const TECHNICAL_MAP_FILTER_ACTIONS_STACK_MEDIA_QUERY = '(max-width: 360px)';
export const technicalMapFilterActionsStackMq = `@media ${TECHNICAL_MAP_FILTER_ACTIONS_STACK_MEDIA_QUERY}`;
